import React from 'react';

type Props = {
  width?: string,
  height?: string,
  stroke?: string,
  className: string,
}

const Help = ({ className, stroke, width, height }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 12.7 12.7"
    width={width}
    height={height}
    className={className}
  >
    <g>
      <g>
        <circle
          cx="6.35"
          cy="6.35"
          r="4.217"
          fill="none"
          stroke={stroke}
          strokeDasharray="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.529"
          opacity="1"
        />
        <text
          xmlSpace="preserve"
          stroke={stroke}
          style={{
            color: stroke,
            lineHeight: '1.25',
            InkscapeFontSpecification: "'Source Sans Pro'",
            WebkitTextAlign: 'center',
            textAlign: 'center',
          }}
          x="6.392"
          y="8.977"
          strokeWidth="0.327"
          fontFamily="Source Sans Pro"
          fontSize="7.842"
          letterSpacing="0"
          opacity="1"
          textAnchor="middle"
          wordSpacing="0"
        >
          <tspan x="6.392" y="8.977" strokeWidth="0.327">
              ?
          </tspan>
        </text>
      </g>
    </g>
  </svg>
);

Help.defaultProps = {
  stroke: '#1a1818',
  width: '48',
  height: '48',
};

export default Help;
